import { IStatus } from 'src/interfaces/status';
import { TSelectItem } from '../components/types';
import { TFunction } from 'src/constants/i18next';

/**
 * Maps the statuses to a select item
 *
 * @param {IStatus[]} statuses
 * @param {TFunction} t
 * @return {*}  {TSelectItem[]}
 */
export const mapStatuses = (statuses: IStatus[], t: TFunction): TSelectItem[] =>
    statuses.map((status) => ({
        value: status._id,
        label: t(`Status.${status.name}`),
    }));
